import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { exportarElemento } from './shared/export';
import { InicioService, VentaDiaria, ImpagoEnviado } from './inicio.service';
import { rangoDias } from './shared/metrics';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {
  @ViewChild('exportRef') exportRef!: ElementRef;

  // Ventas del rango elegido [desde, hasta].
  ventasDiarias: VentaDiaria[] = [];
  // Ventas del periodo anterior (mismo largo, justo antes de `desde`) para comparativas.
  ventasAnterior: VentaDiaria[] = [];
  // Pedidos entregados aun sin cobrar (saldo por cobrar).
  impagos: ImpagoEnviado[] = [];

  // Rango ingresable por UI. Por defecto: ultimas 4 semanas.
  hasta: Date = new Date();
  desde: Date = new Date(new Date().setDate(new Date().getDate() - (7 * 4)));

  constructor(private serv: InicioService) {}

  ngOnInit() {
    this.cargarDatos();
    this.cargarImpagos();
  }

  cargarImpagos() {
    this.serv.getImpagosEnviados().subscribe({
      next: data => this.impagos = data,
      error: e => console.error('Error impagos', e)
    });
  }

  exportar(tipo: 'png' | 'pdf') {
    exportarElemento(
      this.exportRef.nativeElement,
      tipo,
      'dashboard',
      ['.dashboard-export', '.export-actions', '.dashboard-range'],
      ['.range-export']
    );
  }

  onDesdeChange(value: string | number | Date) {
    this.desde = new Date(value);
    this.desde.setHours(0, 0, 0, 0);
    this.onRangoChange();
  }

  onHastaChange(value: string | number | Date) {
    this.hasta = new Date(value);
    this.hasta.setHours(23, 59, 59, 999);
    this.onRangoChange();
  }

  private onRangoChange() {
    if (this.desde && this.hasta && this.desde <= this.hasta) {
      this.cargarDatos();
    }
  }

  cargarDatos() {
    // Desde a medianoche, hasta al final del dia (23:59) para no perder extremos.
    this.desde.setHours(0, 0, 0, 0);
    this.hasta.setHours(23, 59, 59, 999);
    const rango = rangoDias(this.desde, this.hasta);
    // Periodo anterior: mismo largo, justo antes de `desde`.
    const desdeAnterior = new Date(this.desde);
    desdeAnterior.setDate(desdeAnterior.getDate() - rango);
    const hastaAnterior = new Date(this.hasta);
    hastaAnterior.setDate(hastaAnterior.getDate() - rango);

    // Una sola consulta cubre ambos periodos; luego se separan.
    this.serv.getVentasDiarias(desdeAnterior, this.hasta).subscribe({
      next: data => {
        const ventas = data.map(v => ({ ...v, fecha: this.parseFechaLocal(v.fecha) as any }));
        this.ventasDiarias = ventas.filter(v => v.fecha >= this.desde && v.fecha <= this.hasta);
        this.ventasAnterior = ventas.filter(v => v.fecha >= desdeAnterior && v.fecha <= hastaAnterior);
      },
      error: e => console.error('Error ventas', e)
    });
  }

  // Interpreta "YYYY-MM-DD" como medianoche LOCAL (evita el corrimiento por UTC).
  private parseFechaLocal(fecha: string): Date {
    const [y, m, d] = fecha.substring(0, 10).split('-').map(Number);
    return new Date(y, m - 1, d);
  }
}
